import { DEVICES_TYPES_FOR_API } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

export const VIEW_BUTTON_TEXT = "activation.rank.tracker.widget.view.button.text";
export const ERROR_CREATE_RT_TEXT = "activation.rank.tracker.widget.creation.error.text";

export const widgetTexts = {
    title: "activation.rank.tracker.widget.title",
    header: "activation.rank.tracker.widget.header",
    firstPositionTitle: "activation.rank.tracker.widget.first.position.title",
    firstPositionTooltip: "activation.rank.tracker.widget.first.position.tooltip",
    top10Title: "activation.rank.tracker.widget.top10.title",
    top10Tooltip: "activation.rank.tracker.widget.top10.tooltip",
    droppedTitle: "activation.rank.tracker.widget.dropped.title",
    droppedTooltip: "activation.rank.tracker.widget.dropped.tooltip",
    movedToTop3Title: "activation.rank.tracker.widget.moved.to.top3.title",
    movedToTop3Tooltip: "activation.rank.tracker.widget.moved.to.top3.tooltip",
    trackButtonText: "activation.rank.tracker.widget.track.button.text",
    createButtonText: "activation.rank.tracker.widget.create.button.text",
    createButtonTooltip: "activation.rank.tracker.widget.create.button.tooltip",
    createButtonViewerTooltip: "activation.rank.tracker.widget.create.button.viewer.tooltip",
    bannerText: "activation.rank.tracker.widget.banner.text",
    scrapingBadge: "activation.rank.tracker.widget.scraping.badge",
};

export const sourceTexts = {
    [DEVICES_TYPES_FOR_API.DESKTOP]: "activation.rank.tracker.source.desktop",
    [DEVICES_TYPES_FOR_API.MOBILE]: "activation.rank.tracker.source.mobile",
    [DEVICES_TYPES_FOR_API.COMBINED]: "activation.rank.tracker.source.all",
};

export const modalsTexts = {
    firstStepTitle: "activation.rank.tracker.modal.first.step.title",
    nameStepTitle: "activation.rank.tracker.modal.name.step.title",
    firstStepTooltip: "activation.rank.tracker.modal.first.step.tooltip",
    firstStepTooltipLink: "activation.rank.tracker.modal.first.step.tooltip.link",
    firstStepDescription: "activation.rank.tracker.modal.first.step.description",
    firstStepDescription2: "rank.widget.modal.initial.description",
    firstStepNextTooltip: "activation.rank.tracker.modal.first.step.next.tooltip",
    nameStepDescription: "activation.rank.tracker.modal.name.step.description",
    cancelButtonText: "common.cancel",
    createButtonText: "activation.rank.tracker.modal.create.button.text",
    doneButtonText: "common.done",
    competitorsDropdownSearchPlaceholder: "activation.rank.tracker.modal.competitors.dropdown.search.placeholder",
    competitorsDropdownApplyTooltip: "activation.rank.tracker.modal.competitors.dropdown.apply.tooltip",
    selectCountry: "activation.rank.tracker.modal.select.country",
    nameInputLabel: "activation.rank.tracker.modal.name.input.label",
    nameInputPlaceholder: "activation.rank.tracker.modal.name.input.placeholder",
    nameInputMinError: `activation.rank.tracker.modal.name.input.min.error.min`,
    nameInputExistsError: "activation.rank.tracker.modal.name.input.exists.error",
    nameInputMaxLengthError: "activation.rank.tracker.modal.name.input.max.length.error",
    bannerTitle: "activation.rank.tracker.modal.banner.title",
    bannerDescription: "activation.rank.tracker.modal.banner.description",
    bannerTime: "activation.rank.tracker.modal.banner.time",
    competitorsDropdownButtonText: "activation.rank.tracker.modal.competitors.dropdown.button.text",
    defaultCampaignName: "activation.rank.tracker.modal.default.campaign.name",
};
